// Mock data for Lespeziart Con SRL website

export const companyInfo = {
  name: "Lespeziart Con SRL",
  shortName: "LespeziArt-CON",
  cui: "39809164",
  phone: "0755 898 253",
  email: "lespezeanu.t@gmail.com",
  address: "Iași, Blv. Socola nr. 4",
  logo: "https://customer-assets.emergentagent.com/job_651c9566-5343-4243-a383-817877e2f31b/artifacts/u5qyjad5_fulllogo_transparent.png",
  logoAlt: "https://customer-assets.emergentagent.com/job_651c9566-5343-4243-a383-817877e2f31b/artifacts/nfgu5eky_SIGLA%20LESPEzi%20ART.jpg",
  facebook: "https://www.facebook.com/lespeziartconstruct",
  description: "Specialiști în hidroizolații profesionale pentru acoperișuri, terase, fundații și balcoane. Protecție durabilă împotriva infiltrațiilor.",
  yearsExperience: 8
};

export const services = [
  {
    id: 1,
    title: "Hidroizolații Acoperișuri",
    description: "Sisteme complete de hidroizolație pentru acoperișuri cu membrane bituminoase, PVC, EPDM și TPO. Protecție maximă împotriva infiltrațiilor.",
    icon: "Home",
    features: ["Membrane bituminoase", "Membrane PVC/EPDM", "Garanție extinsă", "Consultanță gratuită"]
  },
  {
    id: 2,
    title: "Hidroizolații Terase",
    description: "Soluții profesionale pentru terase circulabile și necirculabile. Impermeabilizare perfectă pentru confort și durabilitate.",
    icon: "Building2",
    features: ["Terase circulabile", "Terase necirculabile", "Finisaje premium", "Drenaj integrat"]
  },
  {
    id: 3,
    title: "Hidroizolații Fundații",
    description: "Protejăm fundațiile construcțiilor împotriva umezelii și infiltrațiilor subterane. Soluții durabile pentru siguranța casei tale.",
    icon: "Layers",
    features: ["Hidroizolație verticală", "Hidroizolație orizontală", "Drenaj perimetral", "Membrane speciale"]
  },
  {
    id: 4,
    title: "Hidroizolații Balcoane",
    description: "Impermeabilizarea balcoanelor pentru a preveni infiltrațiile și degradarea structurii. Soluții estetice și funcționale.",
    icon: "Square",
    features: ["Membrane lichide", "Finisaje decorative", "Scurgere optimizată", "Rezistență UV"]
  }
];

export const portfolioItems = [
  {
    id: 1,
    title: "Proiect Special - Șindrilă Bituminoasă",
    category: "Acoperișuri",
    location: "Iași",
    image: "https://izomag-shop.emergent.host/images/portfolio/image36.jpg",
    description: "Acoperiș cu șindrilă bituminoasă premium pentru o vilă modernă. Proiectul a inclus demontarea vechiului înveliș, montarea unui sistem de hidroizolație complet și instalarea șindrilei bituminoase de înaltă calitate.",
    year: "2023",
    area: "350 mp",
    duration: "2 săptămâni",
    images: [
      "https://izomag-shop.emergent.host/images/portfolio/image36.jpg",
      "https://izomag-shop.emergent.host/images/portfolio/image35.jpg",
      "https://izomag-shop.emergent.host/images/portfolio/image34.jpg",
      "https://izomag-shop.emergent.host/images/portfolio/image33.jpg",
      "https://izomag-shop.emergent.host/images/portfolio/image32.jpg",
      "https://izomag-shop.emergent.host/images/portfolio/image31.jpg"
    ]
  },
  {
    id: 2,
    title: "Campus Palas Iași - Terasă Verde",
    category: "Terase",
    location: "Iași",
    image: "https://izomag-shop.emergent.host/images/portfolio/image25.jpg",
    description: "Terasă verde profesională pentru complexul Campus Palas. Am realizat un sistem complet de hidroizolație cu membrane EPDM, strat de drenaj, substrat și vegetație specifică pentru terase verzi.",
    year: "2022",
    area: "2000 mp",
    duration: "6 săptămâni",
    images: [
      "https://izomag-shop.emergent.host/images/portfolio/image25.jpg",
      "https://izomag-shop.emergent.host/images/portfolio/image26.jpg",
      "https://izomag-shop.emergent.host/images/portfolio/image27.jpg",
      "https://izomag-shop.emergent.host/images/portfolio/image28.jpg",
      "https://izomag-shop.emergent.host/images/portfolio/image29.jpg",
      "https://izomag-shop.emergent.host/images/portfolio/image30.jpg"
    ]
  },
  {
    id: 3,
    title: "CustomEnergy - Showroom & Finisaje",
    category: "Terase",
    location: "Iași",
    image: "https://izomag-shop.emergent.host/images/portfolio/image15.jpg",
    description: "Hidroizolație showroom cu finisaje premium pentru CustomEnergy. Proiectul a inclus impermeabilizarea completă a terasei și finisaje decorative de înaltă calitate.",
    year: "2023",
    area: "800 mp",
    duration: "3 săptămâni",
    images: [
      "https://izomag-shop.emergent.host/images/portfolio/image15.jpg",
      "https://izomag-shop.emergent.host/images/portfolio/image16.jpg",
      "https://izomag-shop.emergent.host/images/portfolio/image17.jpg",
      "https://izomag-shop.emergent.host/images/portfolio/image18.jpg",
      "https://izomag-shop.emergent.host/images/portfolio/image19.jpg",
      "https://izomag-shop.emergent.host/images/portfolio/image20.jpg",
      "https://izomag-shop.emergent.host/images/portfolio/image21.jpg",
      "https://izomag-shop.emergent.host/images/portfolio/image22.jpg",
      "https://izomag-shop.emergent.host/images/portfolio/image23.jpg",
      "https://izomag-shop.emergent.host/images/portfolio/image24.jpg"
    ]
  },
  {
    id: 4,
    title: "Blocuri Rezidențiale AVANERA",
    category: "Terase",
    location: "Suceava",
    image: "https://izomag-shop.emergent.host/images/portfolio/image13.jpg",
    description: "Complex rezidențial AVANERA - hidroizolație terase necirculabile pentru mai multe blocuri. Am utilizat membrane bituminoase premium și sistem de drenaj optimizat.",
    year: "2022",
    area: "3500 mp",
    duration: "8 săptămâni",
    images: [
      "https://izomag-shop.emergent.host/images/portfolio/image13.jpg",
      "https://izomag-shop.emergent.host/images/portfolio/image14.jpg",
      "https://izomag-shop.emergent.host/images/portfolio/image11.jpg",
      "https://izomag-shop.emergent.host/images/portfolio/image12.jpg",
      "https://izomag-shop.emergent.host/images/portfolio/image10.jpg"
    ]
  },
  {
    id: 5,
    title: "Spitalul de Urgențe Bistrița - Heliport",
    category: "Acoperișuri",
    location: "Bistrița",
    image: "https://izomag-shop.emergent.host/images/portfolio/image7.jpg",
    description: "Proiect special - hidroizolație heliport pentru Spitalul de Urgențe Bistrița. Am realizat un sistem rezistent la solicitări mecanice extreme și temperaturi ridicate.",
    year: "2023",
    area: "500 mp",
    duration: "3 săptămâni",
    images: [
      "https://izomag-shop.emergent.host/images/portfolio/image7.jpg",
      "https://izomag-shop.emergent.host/images/portfolio/image8.jpg",
      "https://izomag-shop.emergent.host/images/portfolio/image9.jpg"
    ]
  },
  {
    id: 6,
    title: "Facultatea de Chimie - Universitatea Tehnică",
    category: "Terase",
    location: "Iași",
    image: "https://izomag-shop.emergent.host/images/portfolio/image2.jpg",
    description: "Terasă necirculabilă pentru Facultatea de Chimie - Universitatea Tehnică Iași. Proiect de amploare cu membrane bituminoase și izolație termică.",
    year: "2023",
    area: "7000 mp",
    duration: "12 săptămâni",
    images: [
      "https://izomag-shop.emergent.host/images/portfolio/image2.jpg",
      "https://izomag-shop.emergent.host/images/portfolio/image3.jpg",
      "https://izomag-shop.emergent.host/images/portfolio/image4.jpg",
      "https://izomag-shop.emergent.host/images/portfolio/image5.jpg",
      "https://izomag-shop.emergent.host/images/portfolio/image6.jpg",
      "https://izomag-shop.emergent.host/images/portfolio/image1.jpg"
    ]
  }
];

export const faqItems = [
  {
    question: "De ce este importantă hidroizolația și care sunt beneficiile ei?",
    answer: "Hidroizolația reprezintă o etapă foarte importantă pentru orice construcție, deoarece previne pătrunderea apei și ne ajută să economisim timp și bani pe termen lung. De asemenea, previne formarea fisurilor, creează un mediu mai sănătos și asigură o clădire mai rezistentă în timp."
  },
  {
    question: "Care este rolul hidroizolației?",
    answer: "Hidroizolațiile sau izolațiile hidrofuge au rolul de a preveni infiltrarea apei în orice clădire. Acest lucru este important chiar de la începutul construcției, deoarece reduce semnificativ nivelul de umiditate. Hidroizolarea realizată corect crește nivelul de confort și siguranță al edificiului."
  },
  {
    question: "Ce rol are termo-hidroizolația?",
    answer: "Termo-hidroizolația are un rol esențial în reducerea pierderii de căldură, creând condițiile necesare pentru confort termic. Este un aspect crucial, mai ales pentru construcțiile cu placă de beton. Datorită termo-hidroizolației, căldura nu se pierde iarna, iar vara clădirea nu este supraîncălzită."
  },
  {
    question: "Unde este indicat să realizăm hidroizolație?",
    answer: "Hidroizolația trebuie realizată acolo unde există riscul de pătrundere a apei: pereți, bucătării, băi, balcoane, acoperișuri și subsoluri. Fiecare zonă necesită materiale și tehnici specifice pentru rezultate optime."
  },
  {
    question: "Cât durează o lucrare de hidroizolație?",
    answer: "Durata variază în funcție de complexitatea proiectului. O hidroizolație de balcon poate dura 1-2 zile, în timp ce un acoperiș de bloc poate necesita 1-2 săptămâni. Oferim estimări precise după evaluarea la fața locului."
  },
  {
    question: "Ce garanție oferim pentru lucrări?",
    answer: "Oferim garanție extinsă pentru toate lucrările noastre, variind între 5 și 15 ani în funcție de tipul de hidroizolație și materialele folosite. Garanția acoperă atât manopera cât și materialele utilizate."
  }
];

export const aboutContent = {
  title: "Despre Lespeziart Con",
  subtitle: "Experți în hidroizolații din Iași",
  description: `De mai mulți ani, cu o neobosită energie, realizăm cu responsabilitate față de clienți și mediul înconjurător, hidroizolații în Iași și nu numai, la cel mai înalt nivel calitativ.

Suntem Lespeziart Con și ne-am câștigat încrederea celor cu care am colaborat prin execuția profesională a sistemelor de hidroizolații. Realizăm sisteme complete de termo-hidroizolații atât pentru construcții civile cât și pentru construcții industriale.

Fiecare proiect este tratat cu maximă seriozitate. Ne implicăm activ în toate etapele proiectului, de la consultanță la execuție și mentenanță.`,
  values: [
    {
      title: "Personal Calificat",
      description: "Echipă cu experiență și atestate recunoscute în domeniu"
    },
    {
      title: "Materiale Premium",
      description: "Folosim doar materiale de cea mai bună calitate, testate și certificate"
    },
    {
      title: "Atenție la Detalii",
      description: "Verificăm atent fiecare etapă pentru rezultate excepționale"
    },
    {
      title: "Respectarea Termenelor",
      description: "Finalizăm lucrările la timp, conform contractului"
    }
  ]
};

export const messages = [
  {
    id: 1,
    name: "Ion Popescu",
    phone: "0722123456",
    email: "ion.popescu@email.com",
    message: "Bună ziua, aș dori o ofertă pentru hidroizolația unui acoperiș de casă.",
    date: "2025-08-10",
    read: false
  },
  {
    id: 2,
    name: "Maria Ionescu",
    phone: "0733987654",
    email: "maria.ionescu@email.com",
    message: "Sunt interesat de servicii de hidroizolație pentru terasă. Când puteți veni la o evaluare?",
    date: "2025-08-09",
    read: true
  }
];
